import { AuthLayoutSignin } from "../components/ui/auth-layout-signin"
import { SignInForm } from "../components/auth/signin-form"

export default function SignInPage() {
  return (
    <AuthLayoutSignin title="Welcome Back" subtitle="Sign in to your VirtualScribe account" showBackButton={true}>
      <SignInForm />
    </AuthLayoutSignin>
  )
}
